"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fonts;
(function (fonts) {
    fonts["bold"] = "ITC Avant Garde Gothic";
    fonts["black"] = "AvenirLTPro-Black";
    fonts["heavy"] = "AvenirLTPro-Heavy";
    fonts["roman"] = "AvenirLTPro-Roman";
    fonts["light"] = "AvenirLTPro-Light";
})(fonts || (fonts = {}));
exports.default = fonts;
//# sourceMappingURL=fonts.js.map